<template>
  <router-link
    v-on:click.native="$emit('changeQ', $route.query.q)"
    :to="{ name: $route.name, query: { q: `${attribute} ${setDirection}` } }" >
    {{I18n.t(name)}}
  </router-link>
</template>

<script>
export default {
  name: 'SortLink',
  props: {
    name: String,
    attribute: String,
  },
  computed: {
    setDirection() {
      if (this.$route.query.q && this.$route.query.q.includes(this.attribute)) {
        return this.$route.query.q.includes('asc') ? 'desc' : 'asc';
      }
      return 'asc';
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/sort_link.vue?d81c69c8